<i18n>
  {
    "fr": {
      "ConfiguratorEditorProductTab": {
        "title": "Produit",
        "useCustomTheme": "Choisir parmi nos 750+ modèles à personnaliser",
        "replaceCustomTheme": "Changer mon visuel",
        "selectedProduct": "Style de personnalisation :"
      }
    }
  }
  </i18n>

<template>
  <div :class="blockClasses">
    <h2 v-if="isDocked" :class="`${BLOCK_SELECTOR}__title`">
      {{ $t('ConfiguratorEditorProductTab.title') }}
    </h2>
    <ConfiguratorGlassSettingsSizesRow
      :class="`${BLOCK_SELECTOR}__glass-settings-sizes-row`"
    />
    <span
      v-if="isDocked"
      :class="`${BLOCK_SELECTOR}__content-separator`"
    ></span>
    <ConfiguratorGlassSettingsColorsRow
      :class="`${BLOCK_SELECTOR}__glass-settings-colors-row`"
    />
    <p :class="`${BLOCK_SELECTOR}__selected-product-label`">
      <span :class="`${BLOCK_SELECTOR}__selected-product-label-text`">
        {{ $t('ConfiguratorEditorProductTab.selectedProduct') }}
        <span
          :class="[
            `${BLOCK_SELECTOR}__selected-product-label-value`,
            {
              [`${BLOCK_SELECTOR}__selected-product-label-value--generic-theme`]:
                themeType === ThemeType.GENERIC,
            },
          ]"
        >
          {{ activeProduct.name }}
        </span>
      </span>
    </p>
    <div :class="`${BLOCK_SELECTOR}__custom-theme-list-wrapper`">
      <ConfiguratorCustomThemeList
        :class="`${BLOCK_SELECTOR}__custom-theme-list`"
        :is-docked="isDocked"
        @request-open-theme-picker-modal="
          $emit('request-open-theme-picker-modal')
        "
      />
    </div>
  </div>
</template>

<script>
import {
  ConfiguratorGetters,
  ConfiguratorAction,
  mapState,
  mapGetters as mapConfiguratorGetters,
  mapActions as mapConfiguratorActions,
} from '../../store/modules/configurator';
import { ThemeType } from '../../api/static/ThemeType';
import ConfiguratorGlassSettingsSizesRow from './GlassSettings/ConfiguratorGlassSettingsSizesRow';
import ConfiguratorGlassSettingsColorsRow from './GlassSettings/ConfiguratorGlassSettingsColorsRow';
import ConfiguratorCustomThemeList from './ConfiguratorCustomThemeList';
import ThemePickerImage from '@/images/configurator/pick-theme.webp';
export default {
  name: 'ConfiguratorEditorProductTab',
  emits: ['request-open-theme-picker-modal'],
  components: {
    ConfiguratorGlassSettingsSizesRow,
    ConfiguratorGlassSettingsColorsRow,
    ConfiguratorCustomThemeList,
  },
  props: {
    isDocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BLOCK_SELECTOR: 'configurator-editor-product-tab',
      ThemePickerImage,
      ThemeType,
    };
  },
  computed: {
    blockClasses() {
      return [
        {
          [this.BLOCK_SELECTOR]: true,
          [`${this.BLOCK_SELECTOR}--is-docked`]: this.isDocked,
        },
      ];
    },
    ...mapConfiguratorGetters({
      activeProduct: ConfiguratorGetters.GET_ACTIVE_PRODUCT,
      activeConfiguration: ConfiguratorGetters.GET_ACTIVE_CONFIGURATION,
    }),
    ...mapState({
      themeType: 'themeType',
    }),
  },
  watch: {
    themeType(newValue, oldValue) {
      // Reset customizations when switching from GENERIC to CUSTOM
      if (oldValue === ThemeType.GENERIC && newValue === ThemeType.CUSTOM) {
        this.resetCustomizations();
      }
    },
  },
  methods: {
    ...mapConfiguratorActions({
      resetCustomizations: ConfiguratorAction.RESET_CUSTOMIZATIONS,
    }),
  },
};
</script>

<style lang="scss" scoped>
.configurator-editor-product-tab {
  $block-selector: &;

  padding: 0 0.625rem 2rem;

  &--is-docked {
    background-color: $color-white;
    border-radius: 1.5625rem;
    padding: 1.875rem 2.1875rem;
    margin-bottom: 1rem;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 900;
    text-transform: uppercase;
    color: #2034a6;
    font-family: $font-big-shoulders;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0;

    &::before {
      @extend %icon;
      @extend %icon--tiny-cup;
    }
  }

  &__glass-settings-colors-row,
  &__glass-settings-sizes-row {
    width: fit-content;

    @include breakpoint(90rem) {
      display: inline-flex;
      padding: 0.75rem 0;
    }
  }

  &__content-separator {
    @include breakpoint(90rem) {
      display: inline-block;
      height: 3rem;
      width: 1px;
      margin: 0 1rem -1.25rem 1rem;
      background-color: $color-gray-gallery;
    }
  }

  &__custom-theme-list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    #{$block-selector}--is-docked & {
      flex-direction: row;
    }
  }

  &__custom-theme-list {
    width: 100%;
  }

  &__selected-product-label {
    color: $color-arapawa;
    margin-top: 0.625rem;
  }

  &__selected-product-label-text {
    font-weight: 600;
  }

  &__selected-product-label-value {
    font-weight: 600;
    color: $color-red-amaranth;
  }
}
</style>
